import styled from 'styled-components';
import tw from 'twin.macro';

export const StyledValueText = styled.span`
  ${tw`text-base leading-6 font-medium font-inter text-blue-gray-800`};
  ${(props) => props.css};
`;
